import classNames from "classnames";
import React, { useEffect, useState } from "react";
import sanitizeHtml from "sanitize-html";
import checkmarkIcon from "../assets/images/checkbox.svg";
import { isTrueLike } from "../utilities/common";

import { twMerge } from "tailwind-merge";

export interface CheckboxProps {
  id: string;
  name?: string;
  value: string;
  label?: string;
  required?: boolean;
  defaultChecked?: boolean;
  className?: string;
  checkboxClassName?: string;
  onChange?: (checked: boolean) => void;
  isControlled?: boolean;
}

export const Checkbox = (props: CheckboxProps) => {
  const {
    id,
    name,
    value,
    label = "",
    required,
    defaultChecked,
    className,
    checkboxClassName,
    onChange,
    isControlled = false
  } = props;

  const [checked, setChecked] = useState(defaultChecked);

  const handleChangeChecked = () => {
    setChecked(!checked);
    onChange?.(!checked);
  };

  useEffect(() => {
    if (isControlled) {
      setChecked(isTrueLike(value));
    }
  }, [isControlled, value]);

  return (
    <label
      htmlFor={id}
      className={twMerge(
        classNames("group flex items-center text-neutral-40 text-lg", className)
      )}
    >
      <input
        id={id}
        name={name ?? id}
        type="checkbox"
        value={value}
        className="hidden"
        checked={checked}
        required={required}
        onChange={handleChangeChecked}
      />
      <span
        className={twMerge(
          classNames(
            "inline-flex justify-center items-center size-8 p-0.5 mr-2 border rounded-md transition-all duration-100 focus:outline-none focus:shadow-outline group-hover:border-brand-primary-80",
            checked
              ? "bg-brand-primary-70 border-brand-primary-70 group-hover:bg-brand-primary-80"
              : "bg-transparent border-brand-primary-dim-80",
            checkboxClassName
          )
        )}
      >
        <svg
          width="20"
          height="20"
          className={`${
            checked ? "text-neutral-100" : "text-transparent"
          } fill-current transition duration-100`}
        >
          <use xlinkHref={checkmarkIcon.url} />
        </svg>
      </span>

      <span
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(label)
        }}
      />
    </label>
  );
};

